export default __webpack_public_path__ + "static/media/bzk.72f0cbf4.gif";